import { Check } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export type ItemMarcacao = {
  valor: string;
  rotulo: string;
  icone?: LucideIcon;
};

/**
 * Escolha de VÁRIAS opções — irmã da `Escolha`, que é de uma só.
 *
 * Existe porque os filtros de receita são combináveis ("baixo índice" E "menos
 * de 15 minutos") e antes eram fitas horizontais de pílulas de 28px: alvo
 * pequeno, rolagem lateral e nenhum sinal de que davam para combinar.
 *
 * O alvo é a linha inteira de 72px, não o quadrado. O quadrado é só o sinal do
 * estado — quem tem 70 anos não acerta um quadrado de 20px, e não deveria ter
 * que acertar.
 */
export function Marcacao({
  itens,
  marcados,
  onAlternar,
}: {
  itens: ItemMarcacao[];
  marcados: readonly string[];
  onAlternar: (valor: string) => void;
}) {
  return (
    <div style={{ paddingLeft: "var(--gutter)", paddingRight: "var(--gutter)" }}>
      <div className="overflow-hidden cartao">
        {itens.map((it, i) => {
          const marcado = marcados.includes(it.valor);
          return (
            <button
              key={it.valor}
              type="button"
              role="checkbox"
              aria-checked={marcado}
              onClick={() => onAlternar(it.valor)}
              className={`flex w-full items-center gap-4 px-5 text-left ${
                i > 0 ? "border-t border-border" : ""
              }`}
              style={{ minHeight: "var(--alvo-escolha)" }}
            >
              <span
                className="flex shrink-0 items-center justify-center rounded-md border-2"
                style={{
                  width: 30,
                  height: 30,
                  borderColor: marcado ? "hsl(var(--foreground))" : "hsl(var(--border))",
                  background: marcado ? "hsl(var(--foreground))" : "transparent",
                }}
              >
                {marcado && (
                  <Check
                    className="h-5 w-5"
                    strokeWidth={3}
                    style={{ color: "hsl(var(--background))" }}
                  />
                )}
              </span>
              {it.icone && (
                <it.icone
                  className="h-6 w-6 shrink-0"
                  strokeWidth={2}
                  style={{ color: "var(--tinta-apoio)" }}
                />
              )}
              <span
                className={`min-w-0 flex-1 leading-tight ${marcado ? "font-bold" : "font-medium"}`}
                style={{ fontSize: "var(--t-linha)" }}
              >
                {it.rotulo}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
